import React, { useContext, useState } from 'react';
import { Box, Button, TextField, Typography, CircularProgress } from '@mui/material';
import axios from 'axios';
import { UserService } from '../../../services/usuarios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import UserContext from '../../../context';

const LoginPage: React.FC = () => {

  const navigate = useNavigate();

  const instance = new UserService();

  const ctx = useContext(UserContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();

    setError('');
    setLoading(true);

    const payload = {
      username: email,
      password
  }
    post(payload);
  };
  const post = (payload: any) => {

    instance.signIn(payload)
    .then(data => {
        console.log('res token', data);
        if(data.access_token){

            sessionStorage.setItem('token', data.access_token);

            getProfile(data.access_token);
        }
        
    })
    .catch(error => {
        
        let msg = error.response.data.message;
        if(msg) toast.error(msg)
        console.log('error post singin', error);

    });

  }
  const getProfile = (token: string) => {
    instance.getProfile(token)
    .then(data => {

        if(ctx?.setUser)
        { 
          ctx?.setUser(data);
          navigate("/painel-de-controle", { replace: true });
        }
        
    })
    .catch(error => console.log('error get profile', error))
}
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        bgcolor: 'white',
      }}
    >
        <Box bgcolor="#f3f3f3" p={3} borderRadius={2}>
            <Typography variant="h6" component="h2" gutterBottom>
                Entrar
            </Typography>
            <Box
                component="form"
                onSubmit={handleLogin}
                sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                width: '100%',
                maxWidth: 400,
                }}
            >
                <TextField
                    label="Email"
                    type="email"
                    variant="outlined"
                    color="warning"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    color="warning"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                {error && <Typography color="error">{error}</Typography>}
                <Button
                    type="submit"
                    variant="contained"
                    color="warning"
                    fullWidth
                    disabled={loading}
                >
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Log In'}
                </Button>
            </Box>
        </Box>
    </Box>
  );
};

export default LoginPage;
